import React, { useState } from 'react'
import { toast } from 'react-toastify'
import styled from 'styled-components'

const ForgetPW = () => {
    const [idInput, setIdInput] = useState("")

    const handleSubmit = () => {
        toast.error('기능 개발 중 입니다.')
    }
    return (
    <LoginFormDiv>
        <h1>비밀번호 찾기</h1>
        <Desc>가입한 아이디를 입력하고 비밀번호를 찾으세요</Desc>
        <form onSubmit={handleSubmit}>
            <TextInput
                placeholder="ID"
                value={idInput}
                onChange={(e) => setIdInput(e.target.value)}
            />
            <StyledButton>비밀번호 찾기</StyledButton>
        </form>
    </LoginFormDiv>
    )
}

export default ForgetPW

const LoginFormDiv = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 30px 0px;
    //   gap: 25px;

    form {
        margin-top: 25px;
        gap: 20px;
    }
`

const Desc = styled.div`
    font-size: 14px;
    color: #55565B;
`

const TextInput = styled.input`
    box-sizing: border-box;
    width: 100%;
    border-radius: 12px;
    height: 40px;
    margin: 10px 0;
    padding: 5px 25px;
    line-height: 36px;
    font-size: 15px;
`

const StyledButton = styled.button`
  border: none;
  border-radius: 12px;
  width: 100%;
  height: 40px;
  background-color: #00d1ff;
  text-align: center;
  line-height: 40px;
  font-size: 15px;
  margin-top: 20px;
  cursor: pointer;
`